import { SerializedSmartLinkVersionTheme } from 'fym-shared/src/smartlinks/types';
import { useGetReleaseKitQuery } from '../../../redux/api/fymAPI';
import { smartLinkThemeOfRelease } from './smartLinkThemeOfRelease';

/**
 * The SmartLink theme that follows the release theme of one catalog song (`kit.look.themeId`).
 * Undefined while the kit loads, for a song with no kit, and with no song.
 */
export function useReleaseSmartLinkTheme(
  accountId: number,
  catalogItemUuid: string | undefined
): SerializedSmartLinkVersionTheme | undefined {
  const { data } = useGetReleaseKitQuery(
    { accountId, catalogItemUuid: catalogItemUuid ?? '' },
    { skip: catalogItemUuid === undefined }
  );
  return catalogItemUuid === undefined ? undefined : smartLinkThemeOfRelease(data?.kit);
}
